import * as React from 'react';
import Button from '@telia-front/button';
import { TableCell } from '@telia-front/table';
import Term from './term';
import { cellBEM } from './utils';
const NameCell = (props) => {
    const { item, isMobile, deviceLabel, renderButton = true, width = 2, isDisabled = false } = props;
    const content = renderButton ? (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            `${item.manufacturer} `,
            React.createElement("span", { className: "sr-only" }, item.name)),
        React.createElement(Button, Object.assign({}, item.button, { text: item.name, link: true, disabled: isDisabled })))) : (`${item.manufacturer} ${item.name}`);
    if (isMobile) {
        return (React.createElement(TableCell, { className: cellBEM(), width: width },
            React.createElement(Term, { label: deviceLabel }, content)));
    }
    return (React.createElement(TableCell, { className: cellBEM(), width: width, valign: "top", type: "th", scope: "col" }, content));
};
export default NameCell;
